export default __webpack_public_path__ + "static/media/ksztalty-vege.a8b72c35.svg";